async function modImages() {
  const images = document.querySelectorAll('figure.kg-card.kg-image-card, figure.gh-article-image')

  for (const image of images) {
    const caption = image.querySelector('figcaption span')
    if (!caption?.textContent.trim().endsWith(']')) continue

    const { mods, origStr } = parseModString(caption.textContent)
    caption.textContent = origStr

    // Check if the caption is empty and remove the figcaption if it is
    if (!caption.textContent) {
      caption.parentElement.remove()
    }

    if (mods.has('2x')) {
      const imgEl = image.querySelector('img')
      try {
        const { width, height } = await getOriginalImageSize(imgEl)
        if (width / 2 < imgEl.clientWidth) {
          imgEl.width = width / 2
          imgEl.height = height / 2

          if (imgEl.parentElement.classList.contains('gh-article-image')) {
            imgEl.style.width = `${width / 2}px`
          }
        }
      } catch (error) {}
    }
  }
}

function modVideos() {
  const videos = document.querySelectorAll('figure.kg-card.kg-video-card')
  for (const video of videos) {
    const caption = video.querySelector('figcaption p span')
    if (!caption?.textContent.trim().endsWith(']')) continue

    const { mods, origStr } = parseModString(caption.textContent)
    caption.textContent = origStr

    // Check if the caption is empty and remove the figcaption if it is
    if (!caption.textContent) {
      caption.parentElement.parentElement.remove()
    }

    if (mods.has('2x')) {
      const videoElement = video.querySelector('video')
      if (videoElement) {
        videoElement.width /= 2
        videoElement.height /= 2
      }
    }

    if (mods.has('nocontrols')) {
      const videoPlayerContainer = video.querySelector('.kg-video-player-container')
      if (videoPlayerContainer) {
        videoPlayerContainer.style.display = 'none'
      }
    }
  }
}

function parseModString(input) {
  const regex = /^(.*)\s*\[(.*)]\s*$/
  const match = input.match(regex)
  if (!match) return

  const origStr = match[1].trim()
  const modsArray = match[2].split(',').map((mod) => mod.trim())
  const mods = new Set(modsArray)

  return { mods, str: origStr }
}

async function getOriginalImageSize(imgElement) {
  const img = new Image()
  img.src = imgElement.src

  return new Promise((resolve, reject) => {
    img.onload = () => {
      const originalWidth = img.naturalWidth
      const originalHeight = img.naturalHeight
      resolve({ width: originalWidth, height: originalHeight })
    }

    img.onerror = (error) => {
      reject(error)
    }
  })
}
